import { boxShadowZ1 } from '@cycle-app/ui';
import styled from 'styled-components';

export const PADDING_EDITOR_BOTTOM = 24;

export const TopContainer = styled.div`
  ${boxShadowZ1};
`;
